<template>
<div v-if="theblock">

<!--line_wrap-->

<div class="line_wrap">
<!-- handle -->
<div class="handle"><i class="pi pi-align-justify  pt-2 "></i></div>
<!-- handle -->

<!-- name -->
<div class="name_wrap">
<template v-if="editing">
<div  v-click-away="endEditing" >
<InputText  type="text" v-model="theblock.name" class="w-full p-inputtext-sm animate_class"  v-on:keyup.enter="endEditing"    />
</div>
</template>
<template v-if="!editing">
<p class="text-primary py-1 my-0 name_selector pl-1"  :class="selected" @dblclick="edit" @click="select">{{theblock.name}}</p>  
</template>
</div>
<!-- name -->

<!-- menu -->
<div class="expand_wrap">

</div>
<div class="menu_wrap">
<template v-if="has_children">
  <i class="pi pi-angle-up " v-if="expanded" @click="hideChildren"></i>
  <i class="pi pi-angle-down  " v-else @click="expandChildren"></i>
</template>

<Button type="button"  icon="pi pi-ellipsis-h" @click="toggle($event)" aria-haspopup="true" aria-controls="overlay_menu" class="p-button-primary p-button-text p-button-sm"   />
<Menu id="overlay_menu" ref="menu" :model="menuitems" :popup="true" :autoZIndex="true" :baseZIndex="2000">

</Menu>

</div>
<!-- menu -->

</div>

<!--line_wrap-->


<!--children_wrap-->
<Transition name="expandv">
<div class="children_wrap" v-if="expanded">

</div>
</Transition>
<!--children_wrap-->


</div>


</template>

<script>
export default {

  name: 'SchemaEditorBlockChildLine',
  props:["block"],
  data () {
    return {
    	editing:false,
    	theblock:null,
      expanded:false,
    	menuitems: [
            { 
	            label: 'Kopyala', 
	            icon: 'pi pi-clone',
	            command: () => {
		            this.cloneBlock()
		          }
            },
            { 
	            label: 'Sil', 
	            icon: 'pi pi-trash',
	            command: () => {
		            this.deleteBlock()
		          }
            }
            ]
    }
  },
  watch:{
  	block()
  	{
  		this.theblock = this.block
  	}
  },
  computed:{
  	selected()
  	{
  		if(this.$store.state.customresultdisplays.selected_element)
  		{
  			if(this.$store.state.customresultdisplays.selected_element.id == this.block.id)
  			{
  				return "selected"
  			}
  		}
  		return ""
  	},
    has_children()
    {
      if(this.block.elements.length)
      {
        return true
      }
      return false
    },
  },
  created()
  {
  	this.theblock = this.block
  },
  methods:{
    expandChildren()
    {
      this.expanded = true
    },
    hideChildren()
    {
      this.expanded = false
    },
    deleteBlock()
    {
      this.$emit("deleteBlock",this.block.id)
    },
  	edit()
  	{
  		this.editing = true
  	},
  	addBlock()
    {

    },
    addContent()
    {

    },
    cloneBlock()
    {
      let block = this.sanitizeArray(this.block)
      block.id = this.generateId()
      block.name = block.name+"-Copy"
      this.$emit("addCloneBlock",block)

    },
  	toggle(event) 
  	{      
      this.$refs.menu.toggle(event);
    },
  	endEditing()
  	{
  		this.editing = false
  	},
  	select()
  	{
  		this.$store.dispatch('customresultdisplays/setSelectedElement',this.block) 
  	},
  }

}
</script>

<style lang="css" scoped>
.selected{
	background-color: #dadafc;
	border-radius: 4px;
}
.name_selector{
	cursor: pointer;
  overflow:hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
  width: 130px;
}
.line_wrap{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 6px;
}
.handle{
  width: 24px;
}
.menu_wrap{
  width: 32px;
}
.expand_wrap{
  width: 16px;
}
.expand_wrap>i{
  line-height: 28px;
  cursor: pointer;
}
.expand_wrap>i:hover{
  background-color: #dadafc;
}
.children_wrap{
  width: 100%;
  padding-left: 6px;
}
.expandv-enter-active,
.expandv-leave-active {
  transition: opacity 0.5s ease;
}

.expandv-enter-from,
.expandv-leave-to {
  opacity: 0;
}
@media only screen
and (max-width : 1100px) {

.name_selector{
  width: 50px;
}
}
</style>